import React from 'react'
import styles from './styles.module.css'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from '../Images/circle-info-regular-full.svg'

function PropertiesOwnedDateSold ({
  propertiesOwnedDateSold,
  setPropertiesOwnedDateSold
}) {
  const today = new Date()
  const maxDate = `${today.getFullYear()}-${String(
    today.getMonth() + 1
  ).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`

  const handleStartDateChange = e => {
    setPropertiesOwnedDateSold({
      ...propertiesOwnedDateSold,
      startDate: e.target.value
    })
  }

  const handleEndDateChange = e => {
    setPropertiesOwnedDateSold({
      ...propertiesOwnedDateSold,
      endDate: e.target.value
    })
  }

  return (
    <div className={styles.Container}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          marginBottom: '10px'
        }}
      >
        <h1 className={styles.Title}>Properties owned - Date sold</h1>
        <Tooltip
          title='Filter to people who own properties sold within this date range, or properties that have not been sold.'
          arrow
          placement='top'
          slotProps={{
            popper: {
              sx: {
                '& .MuiTooltip-tooltip': {
                  maxWidth: 500,
                  fontSize: '13px',
                  padding: '8px'
                }
              }
            }
          }}
        >
          <img
            src={infoIcon}
            alt='Properties owned sold date help'
            width={14}
            height={14}
            style={{ cursor: 'pointer' }}
            tabIndex={0}
          />
        </Tooltip>
      </div>

      <div className={styles.FlexContainer}>
        <div className={styles.FlexColumn}>
          <span className={styles.Label}>From</span>
          <input
            className={styles.Input}
            type='date'
            name='startDate'
            max={maxDate}
            value={propertiesOwnedDateSold.startDate}
            onChange={handleStartDateChange}
            disabled={propertiesOwnedDateSold.includeNotSold}
            required
          />
        </div>

        <div className={styles.FlexColumn}>
          <span className={styles.Label}>To</span>
          <input
            className={styles.Input}
            type='date'
            name='endDate'
            max={maxDate}
            value={propertiesOwnedDateSold.endDate}
            onChange={handleEndDateChange}
            disabled={propertiesOwnedDateSold.includeNotSold}
            required
          />
        </div>
      </div>
    </div>
  )
}

export default PropertiesOwnedDateSold
